<template>
	<div>
		<el-form :model="apply" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="applyForm"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="申请编号" prop="name" >
							<input type="hidden" v-model="apply.id" readonly/>
							<input type="hidden" v-model="apply.imgs" readonly/>
							<el-input v-model="apply.applyId" readonly auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="公司名称" prop="companyName">
							<el-input v-model="apply.companyName"  auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="联系人姓名" prop="realName">
							<el-input v-model="apply.realName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系人电话" prop="telephone">
							<el-input v-model="apply.telephone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="联系人地址" prop="address">
							<el-input  v-model="apply.address"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="业务" prop="bussniess">
							<el-input  v-model="apply.bussniess"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="经度" prop="longitude">
							<el-input  v-model="apply.longitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纬度" prop="latitude">
							<el-input  v-model="apply.latitude"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-form-item label="轮播图">
					<el-upload
					  class="upload-demo"
					  multiple
					  list-type="picture-card"
					  action="/wlplat/img/upload"
					  :on-remove="handleRemove"
					  :on-success="handleAvatarSuccess"
					  :file-list="imgFiles"
					  >
					  <el-button size="small" type="primary">点击上传</el-button>
					  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>

				</el-form-item> 
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {auditApplyToEquip} from '@/api/api.js'
	import tools from "@/tools"
	export default {
		data(){
			return {
				apply:{
					id:null,
					applyId:null,
					companyName:"",
					realName:"",
					telephone:"",
					address:"",
					bussniess:"",
					longitude:"",
					latitude:"",
					imgs:[]
				},
				rules: {
		          companyName: [
		            { required: true, message: '请输入公司名称', trigger: 'blur' }
		          ],
		          realName: [
		            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
		          ],
		          telephone: [
		            { required: true, message: '请输入联系人电话', trigger: 'blur' }
		          ],
		          address: [
		            { required: true, message: '请输入公司地址', trigger: 'blur' }
		          ],
		          bussniess: [
		            { required: true, message: '请输入业务范围', trigger: 'blur' }
		          ],
		          longitude: [
		            { required: true, message: '请输入纬度', trigger: 'blur' }
		          ],
		          latitude: [
		            { required: true, message: '请输入经度', trigger: 'blur' }
		          ]
		          
		        },
 
				imgFiles:[],
				addLoading:false
			}

		},
		created:function() {
			
			this.apply=Object.assign({},this.$route.params);
			this.apply.applyId = this.apply.id;
			this.apply.id = null;

		},
		methods:{
			addSubmit(){
				this.$refs["applyForm"].validate((valid)=>{
					this.addLoading=true;
					if(valid){
						auditApplyToEquip(this.apply).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					}
					this.addLoading=false;		
				});
			},
			handleAvatarSuccess(res, file,fileList) {
				if(this.apply.imgs){
					this.apply.imgs.push(res.data);
				}else{
					this.apply.imgs = []
					this.apply.imgs.push(res.data);
				}
		    },
		    searchLine(){
				this.reload();
			},
		    handleRemove(file, fileList){
		    	tools.arrayRemove(this.apply.imgs,file.url);
		    },
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>